<div class="main-container">
  <p-toast [preventOpenDuplicates]="true"></p-toast>
  <ngx-spinner size="medium" color="#ffa500" type="ball-pulse"></ngx-spinner>
  <router-outlet></router-outlet>
</div>